import React, { useEffect, useState } from 'react'
import { InputAdornment, TextField, Typography, Snackbar } from '@material-ui/core';
import CloseImage from '../../assets/ic_close.png';
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import profile from '../../assets/profile.png';
import editProf from '../../assets/editProf.png';
import ImageUploader from 'react-images-upload';
import MuiAlert from '@material-ui/lab/Alert';
import UploadFileImage from '../components/UploadFileImage';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


export default function DetailDocter(props) {
    const [poli, setListPoli] = useState([])
    const [uploadVisible, setUploadVisible] = useState(false)
    const [photo, setPhoto] = useState("")
    const [poliklinik, setPoliklinik] = useState([])
    const [time, setTime] = useState([])
    const [image, setImage] = useState([profile])
    const [pictures, setPicture] = useState([])
    const [id, setID] = useState(null)
    const [messageAlert, setMessageAlert] = React.useState("")
    const [statusAlert, setStatusAlert] = React.useState("")
    const [openAlert, setOpenAlert] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null)
    const [visibleError, setVisibleError] = React.useState(false);
    const [newDocter, setnewDocter] = useState({
        kodeDokter: "",
        alamat: "",
        durasiperiksa: "",
        namaDokter: "",
        tahunAktif: "",
        noSTR: "",
        graduate: "",
        keteranganDokter: "",
        kodeAntrian: "",
        referalVclaim: "",
        referalHfis: "",
    })
    const listSesi = [
        { name: "Tidak", id: 0 },
        { name: "Ya", id: 1 },
    ]
    const [prefixSesi, setPrefixSesi] = useState(listSesi[0])

    const listIGD = [
        { name: "Tidak", id: 0 },
        { name: "Ya", id: 1 },
    ]
    const [igd, setIGD] = useState(listIGD[0])
    const [percentage, setpercentage] = useState('0')
    const [uploadstatus, setuploadstatus] = useState("")
    const [result, setresult] = useState("")
    // const [referalVclaim, setReferalVclaim] = React.useState(null)
    // const [referalHfis, setReferalHfis] = React.useState(null)

    const fileHandler = (event) => {
        console.log(event);
        if (event) {
            let images = URL.createObjectURL(event)
            setPhoto(images)
            setPicture([event])
            console.log(images);
        }
    }

    useEffect(() => {
        const detail = props.detail[0]
        console.log(props.detail);
        setnewDocter({
            ...newDocter,
            kodeDokter: detail.code === null ? "" : detail.code,
            alamat: detail.address === null ? "" : detail.address,
            durasiperiksa: detail.time === null ? "" : detail.time,
            namaDokter: detail.name === null ? "" : detail.name,
            tahunAktif: detail.start_year === null ? "" : detail.start_year,
            noSTR: detail.str_no === null ? "" : detail.str_no,
            graduate: detail.graduate === null ? "" : detail.graduate,
            keteranganDokter: detail.desc === null ? "" : detail.desc,
            phone: detail.phone === null ? "" : detail.phone,
            kodeAntrian: detail.queue_code === null ? "" : detail.queue_code,
            referalVclaim: detail.bpjs_vclaim_reference_code === null ? "" : detail.bpjs_vclaim_reference_code,
            referalHfis: detail.bpjs_hfis_reference_code === null ? "" : detail.bpjs_hfis_reference_code
        })
        setID(detail.id)
        let IndexID = listSesi.findIndex((val) => val.id === detail.use_doctor_session_queue)
        if (IndexID > -1) {
            setPrefixSesi(listSesi[IndexID])
        }
        let idx = listIGD.findIndex((val) => val.id === detail.is_igd)
        if (idx > -1) {
            setIGD(listIGD[idx])
        }
        if (detail.polyclinic.length > 0) {
            let data = []
            detail.polyclinic.map((item) => {
                if (item.deleted_at === null) {
                    data.push(item)
                }
            })
            setPoliklinik(data)
        }
        setPhoto(detail.media_path === null ? "" : detail.media_path)
        getDataPoli()
        forceUpdate()
    }, [])

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target
        setnewDocter({
            ...newDocter,
            [name]: value
        })
    }

    const getDataPoli = (value) => {
        if (value === undefined || value === "") {
            api.create().getListPoli(value === undefined ? "" : value).then(response => {
                console.log(response)
                if (response.data) {
                    let listPoli = []
                    response.data.data.map((item, index) => {
                        if (item.deleted_at === null) {
                            listPoli.push({
                                id: item.id,
                                name: String(item.name).trim()
                            })
                        }
                    })
                    setListPoli(listPoli)
                }
            })
        }
    }

    const updateDokter = () => {
        console.log(newDocter);
        let poli = []
        if (poliklinik !== null) {
            poliklinik.map(item => {
                poli.push(item.id)
            })
        }
        let pic = pictures[0]
        let formData = new FormData()
        formData.append('id', id)
        formData.append('dr_code', newDocter.kodeDokter)
        formData.append('str_no', newDocter.noSTR)
        formData.append('desc', newDocter.keteranganDokter)
        formData.append('polyclinic_id', JSON.stringify(poli))
        formData.append('name', newDocter.namaDokter)
        formData.append('queue_code', newDocter.kodeAntrian)
        formData.append('use_doctor_session_queue', prefixSesi.id)
        formData.append('is_igd', igd.id)
        formData.append('bpjs_vclaim_reference_code', newDocter.referalVclaim)
        formData.append('bpjs_hfis_reference_code', newDocter.referalHfis)
        // if (newDocter.tahunAktif !== "") {
        newDocter.tahunAktif !== "" && formData.append('start_year', newDocter.tahunAktif)
        // }
        // if (newDocter.graduate !== "") {
        formData.append('graduate', newDocter.graduate)
        // }
        if (newDocter.phone !== "") {
            formData.append('phone', newDocter.phone)
        }
        formData.append('remark', "")
        formData.append('photo', pictures.length > 0 ? pictures[0] : "")
        console.log(...formData);
        api.create().updateDokter(formData).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    props.onClose()
                    props.getData()
                } else {
                    setStatusAlert('warning')
                    setMessageAlert(response.data.data)
                    setOpenAlert(true)
                }
            }
        })
    }

    const onDrop = (pictureFiles, pictureDataURLs) => {
        console.log(pictureDataURLs, '----------------1');
        console.log(pictureFiles);
        setPhoto(pictureDataURLs)
        let pic = pictureFiles
        pic[0] && String(pictureFiles[0].name).replace(',', '.')
        setPicture(pic)
    }

    return (
        <div className="App app-popup-show">
            <Snackbar open={openAlert} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={statusAlert}>
                    {messageAlert}
                </Alert>
            </Snackbar>
            <div className="popup-content background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Detail Dokter</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div style={{ margin: 'auto', width: 135, height: 135, backgroundColor: 'green', marginTop: 20, borderRadius: 70 }}>
                    <img style={{ width: 135, height: 135, borderRadius: 70 }} src={photo === "" ? profile : photo} />
                    <div style={{ marginTop: -19, marginLeft: 7 }}>
                        <img src={editProf} style={{ width: 18.6, height: 18.6, marginTop: -45, cursor: 'pointer' }}
                            onClick={(e) => {
                                setPicture("")
                                setUploadVisible(true)
                            }}
                        />
                    </div>
                </div>
                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="kodeDokter"
                                name="kodeDokter"
                                label="Kode Dokter"
                                placeholder={"kode dokter"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.kodeDokter}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="namaDokter"
                                name="namaDokter"
                                label="Nama Dokter"
                                placeholder={"input nama dokter"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.namaDokter}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="phone"
                                name="phone"
                                label="No. Handphone"
                                placeholder={"input no telephone"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    maxLength: 12
                                }}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start" style={{ margin: 0, marginRight: 5 }}>+62</InputAdornment>,
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.phone}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="kodeAntrian"
                                name="kodeAntrian"
                                label="Kode Antrian"
                                placeholder={"Input Kode Antrian"}
                                required
                                onChange={(e) => {
                                    handleOnChange(e)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    maxLength: 2
                                }}
                                InputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.kodeAntrian}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                multiple
                                options={poli}
                                getOptionLabel={(option) => option.name}
                                debug
                                name='poliklinik'
                                id="tipe"

                                onChange={(event, newInputValue) => {
                                    setPoliklinik(newInputValue)
                                    console.log(poliklinik);
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Klinik"
                                    />
                                }
                                value={poliklinik}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                options={listIGD}
                                getOptionLabel={(option) => option.name}
                                disableClearable
                                onChange={(event, newInputValue) => {
                                    setIGD(newInputValue)
                                }}
                                value={igd}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Dokter IGD"
                                    />
                                }
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="referalHfis"
                                name="referalHfis"
                                label="Kode Referensi HFIS"
                                placeholder={"input kode Referensi HFIS"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.referalHfis}
                            />
                        </div>
                    </div>

                    <div className="column-2">
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="noSTR"
                                name="noSTR"
                                label="No STR"
                                placeholder={"input No STR"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.noSTR}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="keteranganDokter"
                                name="keteranganDokter"
                                label="Keterangan Dokter"
                                placeholder={"input Keterangan Dokter"}
                                multiline
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                inputProps={{
                                    maxLength: 120
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.keteranganDokter}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="graduate"
                                name="graduate"
                                label="Lulusan"
                                placeholder={"input Lulusan"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.graduate}
                            />
                        </div>
                        <div className="">
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="tahunAktif"
                                name="tahunAktif"
                                label="Tahun Aktif"
                                placeholder={"Input Tahun Aktif"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.tahunAktif}
                            />
                        </div>
                        <div style={{ marginTop: 15 }}>
                            <Autocomplete
                                options={listSesi}
                                getOptionLabel={(option) => option.name}
                                disableClearable
                                onChange={(event, newInputValue) => {
                                    setPrefixSesi(newInputValue)
                                }}
                                value={prefixSesi}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Prefix Antrian Sesi Dokter"
                                    />
                                }
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <TextField
                                style={{ width: '100%', marginTop: 15 }}
                                id="referalVclaim"
                                name="referalVclaim"
                                label="Kode Referensi VCLAIM"
                                placeholder={"input kode Referensi VCLAIM"}
                                onChange={(e) => handleOnChange(e)}
                                inputProps={{
                                    style: {
                                        fontSize: 14,
                                    }
                                }}
                                InputLabelProps={{
                                    style: {
                                        fontSize: 14,
                                        color: '#7e8085',
                                    }
                                }}
                                value={newDocter.referalVclaim}
                            />
                        </div>
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => updateDokter(e)} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>

            {uploadVisible && (
                <div className="App app-popup-show" style={{ zIndex: 5000 }}>
                    <div className="popup-content background-white border-radius" style={{ borderRadius: 8 }}>
                        <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                <div className="popup-title">
                                    <span style={{ color: 'black', fontSize: 18 }}>Upload File</span>
                                </div>
                            </div>
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => {
                                        setUploadVisible(false)
                                        setPicture("")
                                    }}
                                >
                                    <img src={CloseImage} />
                                </button>
                            </div>
                        </div>
                        {/* <ImageUploader
                            withIcon={true}
                            withPreview
                            buttonStyles={pictures.length > 0 ? { display: 'none' } : null}
                            buttonText={'Select Picture'}
                            onChange={onDrop}
                            name={'test'}
                            imgExtension={['.jpg', '.gif', '.png', '.gif', '.jpeg']}
                            maxFileSize={1000000}
                            label={"Max file size: 1 Mb, accepted: jpg or png"}
                        /> */}
                        {image !== "" && (
                            <div style={{ padding: 20 }}>
                                <img src={photo} style={{ height: 180 }}></img>
                            </div>
                        )}
                        <UploadFileImage
                            type={uploadstatus}
                            percentage={percentage}
                            result={result}
                            acceptedFiles={["JPG", "JPEG", "PNG", "GIF"]}
                            onHandle={(dt) => {
                                fileHandler(dt)
                                // setuploadstatus('idle')
                                // setpercentage('0')
                            }}
                            onUpload={() => {
                                setUploadVisible(false)
                                // isUpload && checkPreview()
                                // this.uploadAttachment(this.state.formData)
                            }}
                        />
                        {/* {pictures.length > 0 ?
                            <div style={{ display: 'grid', margin: 20 }}>
                                <div style={{ justifySelf: 'center' }}>
                                    <span style={{ color: '#fff', padding: 20, paddingBottom: 10, paddingTop: 10, borderRadius: 15, cursor: 'pointer', backgroundColor: '#2a9c6c' }} onClick={() => setUploadVisible(false)}>Upload</span>
                                </div>
                            </div> : null
                        } */}
                    </div>
                </div>
            )}
        </div>
    )
}